<!--
 * @Description: iief5
 * @Date: 2019-10-29 10:21:46
 * @LastEditors: Ji Yinghao
 * @LastEditTime: 2019-11-04 16:25:43
 -->

<template>
  <v-list-item-content>
              <v-list-item-title>IIEF-5 评分表</v-list-item-title>
              <v-card class="mx-auto" >
                    <v-card-text>
                    <p class="display-1 text--primary">
                       {{ iief5Number }} 分
                       <v-chip class="ma-2" color="red" text-color="white" v-if="iief5Number <= 7"> 重度异常</v-chip>
                       <v-chip class="ma-2" color="orange" text-color="white" v-if="iief5Number > 7 && iief5Number <= 11"> 中度异常</v-chip>
                       <v-chip class="ma-2" color="light-green" text-color="white" v-if="iief5Number > 11 && iief5Number <= 21"> 轻度异常</v-chip>
                       <v-chip class="ma-2" color="green" text-color="white" v-if="iief5Number > 21"> 正常 </v-chip>
                    </p>
                    <p>测分时间：{{ iief5.create_time | time }}</p>
                    <div class="text--primary">
                        1. 您对获得勃起和维持勃起的自信程度如何？<br>
                        <v-chip class="ma-2" :class="{'primary primary--text':iief5.scores[0] == 0}" outlined pill > 没有 </v-chip>
                        <v-chip class="ma-2" :class="{'primary primary--text':iief5.scores[0] == 1}" outlined pill > 很低 </v-chip>
                        <v-chip class="ma-2" :class="{'primary primary--text':iief5.scores[0] == 2}" outlined pill > 低 </v-chip>
                        <v-chip class="ma-2" :class="{'primary primary--text':iief5.scores[0] == 3}" outlined pill > 中等 </v-chip>
                        <v-chip class="ma-2" :class="{'primary primary--text':iief5.scores[0] == 4}" outlined pill > 高 </v-chip>
                        <v-chip class="ma-2" :class="{'primary primary--text':iief5.scores[0] == 5}" outlined pill > 很高 </v-chip>
                    </div>
                    <br>
                    <div class="text--primary">
                        2. 您受到性刺激而有阴茎勃起时，有多少次能够插入？<br>
                        <v-chip class="ma-2" :class="{'primary primary--text':iief5.scores[1] == 0}" outlined pill > 无性活动 </v-chip>
                        <v-chip class="ma-2" :class="{'primary primary--text':iief5.scores[1] == 1}" outlined pill > 几乎没有/完全没有 </v-chip>
                        <v-chip class="ma-2" :class="{'primary primary--text':iief5.scores[1] == 2}" outlined pill > 少数几次（远少于一半时候） </v-chip>
                        <v-chip class="ma-2" :class="{'primary primary--text':iief5.scores[1] == 3}" outlined pill > 有时（约一半时候） </v-chip>
                        <v-chip class="ma-2" :class="{'primary primary--text':iief5.scores[1] == 4}" outlined pill > 大多数时候（远多于一半时候） </v-chip>
                        <v-chip class="ma-2" :class="{'primary primary--text':iief5.scores[1] == 5}" outlined pill > 几乎总是/总是 </v-chip>
                    </div>
                    <br>
                    <div class="text--primary">
                        3. 您性交时，阴茎插入后，有多少次能够维持勃起状态？<br>
                        <v-chip class="ma-2" :class="{'primary primary--text':iief5.scores[2] == 0}" outlined pill > 无性活动 </v-chip>
                        <v-chip class="ma-2" :class="{'primary primary--text':iief5.scores[2] == 1}" outlined pill > 几乎没有/完全没有 </v-chip>
                        <v-chip class="ma-2" :class="{'primary primary--text':iief5.scores[2] == 2}" outlined pill > 少数几次（远少于一半时候） </v-chip>
                        <v-chip class="ma-2" :class="{'primary primary--text':iief5.scores[2] == 3}" outlined pill > 有时（约一半时候） </v-chip>
                        <v-chip class="ma-2" :class="{'primary primary--text':iief5.scores[2] == 4}" outlined pill > 大多数时候（远多于一半时候） </v-chip>
                        <v-chip class="ma-2" :class="{'primary primary--text':iief5.scores[2] == 5}" outlined pill > 几乎总是/总是 </v-chip>
                    </div>
                    <br>
                    <div class="text--primary">
                        4. 您性交时，维持阴茎勃起至性交完成，需要多大困难？<br>
                        <v-chip class="ma-2" :class="{'primary primary--text':iief5.scores[3] == 0}" outlined pill > 无性活动 </v-chip>
                        <v-chip class="ma-2" :class="{'primary primary--text':iief5.scores[3] == 1}" outlined pill > 困难极大 </v-chip>
                        <v-chip class="ma-2" :class="{'primary primary--text':iief5.scores[3] == 2}" outlined pill > 困难很大 </v-chip>
                        <v-chip class="ma-2" :class="{'primary primary--text':iief5.scores[3] == 3}" outlined pill > 困难 </v-chip>
                        <v-chip class="ma-2" :class="{'primary primary--text':iief5.scores[3] == 4}" outlined pill > 有点困难 </v-chip>
                        <v-chip class="ma-2" :class="{'primary primary--text':iief5.scores[3] == 5}" outlined pill > 不困难 </v-chip>
                    </div>
                    <br>
                    <div class="text--primary">
                        5. 您性交时，有多少次感到满足？<br>
                        <v-chip class="ma-2" :class="{'primary primary--text':iief5.scores[4] == 0}" outlined pill > 无性活动 </v-chip>
                        <v-chip class="ma-2" :class="{'primary primary--text':iief5.scores[4] == 1}" outlined pill > 几乎没有/完全没有 </v-chip>
                        <v-chip class="ma-2" :class="{'primary primary--text':iief5.scores[4] == 2}" outlined pill > 少数几次（远少于一半时候） </v-chip>
                        <v-chip class="ma-2" :class="{'primary primary--text':iief5.scores[4] == 3}" outlined pill > 有时（约一半时候） </v-chip>
                        <v-chip class="ma-2" :class="{'primary primary--text':iief5.scores[4] == 4}" outlined pill > 大多数时候（远多于一半时候） </v-chip>
                        <v-chip class="ma-2" :class="{'primary primary--text':iief5.scores[4] == 5}" outlined pill > 几乎总是/总是 </v-chip>
                    </div>
                    </v-card-text>
                    <v-card-actions>
                    <!-- <v-btn text color="deep-purple accent-4" >
                        Learn More
                    </v-btn> -->
                    </v-card-actions>
                </v-card>
            </v-list-item-content>
</template>

<script>
export default {
    name:'IIEF5',
    props:{
        iief5:{
            create_time:Number,
            scores:Array
        },
        iief5Number: Number
    },
  data() {
    return {
      dialog: false,
      data: {}
    };
  },
  methods: {
    info(state, data) {
      this.dialog = state;
      this.data = data;
    },
  }
};
</script>

<style>
</style>